import { relationships } from "@rocicorp/zero";
import { projectResourceLink } from "./project-resource-link";
import { resourceLink } from "./resource-link";

export const projectResourceLinkRelationships = relationships(projectResourceLink, ({ one }) => ({
	resourceLink: one({
		sourceField: ["linkId"],
		destField: ["id"],
		destSchema: resourceLink,
	}),
}));
